<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="deduct_coupon_rules"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_deduct_coupon_index_429')">
      <Form ref="category"
            :model="deduct_coupon_rule"
            :label-width="80">
        <Form-item :label="$t('pages_ai_image_158')"
                   prop="name">
          <Input type="text"
                 v-model="deduct_coupon_rule.name" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_452')"
                   prop="deduct_category_type">
          <Select label-in-value
                  :disabled="formType ==='edit'"
                  :value="deduct_coupon_rule.deduct_category_type" @on-change="changeDeductType">
            <Option v-for="item in deduct_category_types"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_453')" v-if="deduct_coupon_rule.deduct_category_type" prop="deduct_category_id">
          <scope-of-use :type="deduct_coupon_rule.deduct_category_type" :modalType="formType" :name="deduct_coupon_rule.deduct_category_name" v-model="deduct_coupon_rule.deduct_category_id" @changeName="changeDeductCategoryName"/>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_443')"
                   prop="use_it_minimum_consumption">
          <Input type="text" number
                 v-model="deduct_coupon_rule.use_it_minimum_consumption" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_454')"
                   prop="fetch_it_minimum_consumption">
          <Input type="text" number
                 v-model="deduct_coupon_rule.fetch_it_minimum_consumption" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_436')"
                   prop="price">
          <Input type="text" number
                 v-model="deduct_coupon_rule.price" />
        </Form-item>
        <Form-item :label="$t('pages_bookings_detail_223')"
                   prop="quantity">
          <Input type="text" number
                 v-model="deduct_coupon_rule.quantity" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_455')"
                   prop="expired_date_category">
          <Select label-in-value
                  v-model="deduct_coupon_rule.expired_date_category">
            <Option v-for="item in expired_date_categorys"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_445')"
                   prop="expired_date" v-if="deduct_coupon_rule.expired_date_category === 'fixed_date'">
          <Date-picker v-model="deduct_coupon_rule.expired_date" type="datetime" format="yyyy-MM-dd HH:mm" :placeholder="$t('pages_deduct_coupon_rule_index_456')" style="width: 100%"></Date-picker>
    <br>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_457')"
                   prop="expired_on_received_some_days" v-if="deduct_coupon_rule.expired_date_category === 'received_some_days'">
          <Input type="text" number
                 v-model="deduct_coupon_rule.expired_on_received_some_days" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_rule_index_458')"
                   prop="effective_date_category">
          <Select label-in-value
                  v-model="deduct_coupon_rule.effective_date_category">
            <Option v-for="item in effective_date_categorys"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_444')"
                   prop="effective_date" v-if="deduct_coupon_rule.effective_date_category === 'fixed_date'">
          <Date-picker v-model="deduct_coupon_rule.effective_date" type="datetime" format="yyyy-MM-dd HH:mm" :placeholder="$t('pages_deduct_coupon_rule_index_456')" style="width: 100%"></Date-picker>
        </Form-item>
         <Form-item :label="$t('pages_balance_transaction_index_176')"
                   prop="is_running">
          <i-switch v-model="deduct_coupon_rule.is_running" size="large">
            <span slot="open">{{$t('pages_birthday_discount_index_208')}}</span>
            <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable, booleanChinese } from '@/libs/table-render'
import ScopeOfUse from './components/ScopeOfUse/index'

export default {
  components: {
    TablePaginate,
    ScopeOfUse
  },
  data () {
    const that = this;
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_deduct_coupon_index_430'),
          key: 'name',
          width: 130,
        },
        {
          title: i18n.t('pages_deduct_coupon_index_431'),
          key: 'deduct_category_type',
          width: 100,
          render: (h, params) => {
            return h('span', that.getSelectName('deduct_category_type', params.row.deduct_category_type))
          }
        },
        {
          title: i18n.t('pages_deduct_coupon_rule_index_459'),
          key: 'deduct_category_name',
          width: 100,
        },
        {
          title: i18n.t('pages_deduct_coupon_rule_index_460'),
          key: 'use_it_minimum_consumption',
          width: 140,
        },
        {
          title: i18n.t('pages_deduct_coupon_rule_index_461'),
          key: 'fetch_it_minimum_consumption',
          width: 140,
        },
        {
          title: i18n.t('pages_deduct_coupon_index_436'),
          key: 'price',
          width: 100,
        },
        {
          title: i18n.t('pages_bookings_detail_223'),
          key: 'quantity',
          width: 100,
        },
        {
          title: i18n.t('pages_deduct_coupon_index_440'),
          key: 'effective_date_category',
          width: 100,
          render: (h, params) => {
            return h('span', that.getSelectName('effective_date_category', params.row.effective_date_category))
          }
        },
        {
          title: i18n.t('pages_deduct_coupon_index_437'),
          key: 'expired_date_category',
          width: 100,
          render: (h, params) => {
            return h('span', that.getSelectName('expired_date_category', params.row.expired_date_category))
          }
        },
        {
          title: i18n.t('pages_birthday_discount_index_208'),
          key: 'is_running',
          align: 'center',
          width: 100,
          render: (h, params) => {
            const children = []
            children.push(booleanChinese(
              h,
              params.row.is_running))
            return h('div', children)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          width: 150,
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ],
      deduct_category_types: [
        { name: i18n.t('pages_deduct_coupon_index_446'), value: 'shop' },
        { name: i18n.t('pages_booking_store_products_index_213'), value: 'fresh_category' },
        { name: i18n.t('pages_deduct_coupon_index_447'), value: 'fresh_product' },
      ],
      expired_date_categorys: [
        { name: i18n.t('pages_deduct_coupon_rule_index_462'), value: 'fixed_date' },
        { name: i18n.t('pages_deduct_coupon_rule_index_463'), value: 'received_some_days' },
      ],
      effective_date_categorys: [
        { name: i18n.t('pages_deduct_coupon_rule_index_464'), value: 'fixed_date' },
        { name: i18n.t('pages_deduct_coupon_rule_index_465'), value: 'received_date' },
        { name: i18n.t('pages_deduct_coupon_rule_index_466'), value: 'received_next_date' },
      ],
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.deduct_coupon_rule_partition_index()
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('deduct_coupon_rule', ['deduct_coupon_rule', 'deduct_coupon_rules', 'meta', 'loading']),
    ...mapState('deduct_coupon_rule_partition', ['deduct_coupon_rule_partitions'])

  },
  methods: {
    ...mapActions('deduct_coupon_rule', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('deduct_coupon_rule_partition', {
      deduct_coupon_rule_partition_index: 'index'
    }),
    ...mapActions('setting', ['display', 'upgrade']),

    ...mapMutations('deduct_coupon_rule', ['changeQuery']),
    changeDeductType (obj) {
      this.$set(this.deduct_coupon_rule, 'deduct_category_type', obj.value)
      if (obj.value !== 'shop' && this.formType === 'edit') {
        console.log('obj.value', obj.value);
        this.deduct_coupon_rule.deduct_category_name = '';
        this.deduct_coupon_rule.deduct_category_id = null
      }
    },
    changeDeductCategoryName (name) {
      console.log('name', name);
      this.deduct_coupon_rule.deduct_category_name = name
    },
    getSelectName (type, value) {
      const result = this[`${type}s`].find(item => item.value === value)
      return result.name
    },
    routeSeats (row) {
      this.$router.push({
        path: '/deduct_coupon_rules/seats',
        query: {
          fresh_deduct_coupon_rule_id: row.id,
          deduct_coupon_rule_name: encodeURIComponent(row.name),
        }
      })
    },
    getdeduct_coupon_rulePartitionName ({ row }) {
      const result = this.deduct_coupon_rule_partitions.find(item => item.id === row.id)
      return result ? result.name : ''
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    uploadedUrl (url) {
      this.deduct_coupon_rule.image = url
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.deduct_coupon_rule)
      } else if (this.formType === 'new') {
        await this.create(this.deduct_coupon_rule)
      }
      this.modalShow = false
    },
    change_deduct_coupon_rule_auto_upgrade () {
      this.upgrade({ deduct_coupon_rule_auto_upgrade: this.setting.deduct_coupon_rule_auto_upgrade })
    },
  }
}
</script>
